<template>
<div class="col backgroundForm">
    <div class="col col-md-10 offset-md-1">
        <div class="col col-md-10 offset-md-1">
            <div class="alert alert-danger" role="alert">
                <h4 class="alert-heading">Contravenciones</h4>        
                <hr>
                <p>Formulario de Sancion a las Contravenciones a la Prevencion de la Contaminacion y Seguridad a la Navegacion</p>
            </div>
            <h6 class="col" align="center"> <b>UFV:</b>{{ ufv }} al {{ ufv_date }} <button class="btn btn-success" @click="callUfv"> <font-awesome-icon icon="sync-alt" size="lg" /> </button> </h6>
            <h6 class="col" align="center"> <b>C:</b> {{ cChangeCUT.toFixed(5) }} <b>A:</b> {{ activity_select.factor > 0 ? activity_select.factor:0}} <b>P:</b> {{ propulsion_select.factor ? propulsion_select.factor : 0 }} <b>pcp:</b> {{ propulsion_select.factor_penalty ? propulsion_select.factor_penalty : 0 }} <b>pca:</b> {{ activity_select.factor_penalty > 0 ? activity_select.factor_penalty:0}} <b>#Infracciones:</b> {{ penalty_lists_approve.length>0 ? penalty_lists_approve.length : 0 }} </h6>
        </div>

        <h6>TIPO CONTRAVENCION</h6>
        <hr>
        <div class="form-row">
            <div class="form-group col-12 col-md-8 offset-md-2">
                <label for="nombre_embarcacion">Contravencion</label>  
                            <!-- listar las capitanias -->
                <select name="contravension" class="form-control" id="contravension" v-model="category_penalty_select" @change="callInfregments">
                    <option v-for="cp in category_penalty" :value="cp" :key="cp.id">{{ cp.detail }}</option>
                    <!-- <option v-for="port in ports" :value="port" :key="port.id">{{ port.name_port }}</option> -->
                </select>                         
            </div>
        </div>

        <h6>GENERALES DE LA NAVE / EMBARCACION</h6>
        <hr>
        <div class="form-row">
            <div class="form-group col-12 col-md-6">
                <label for="name">Nombre Nave/Embarcacion <span class="required-text">*</span></label>           
                <input type="text" class="form-control" id="name_ship" placeholder="Nombre Nave/Embarcacion........."  autocomplete="off" v-model="dts_penalty.name_boat" :readonly="is_disabled">
            </div>

            <div class="form-group col-12 col-md-6">
                <label for="enrollment">Matricula <span class="required-text">*</span></label>
                <vue-bootstrap-typeahead                                        
                        v-model="enrollment_temp"
                        :data="enrollments_register"
                        :serializer="item => item.enrollment"
                        @hit="mSelectedEnrollment"
                        :placeholder="placeholder_enrollment"
                        v-if="!is_disabled"
                    />
                <div class="input-group col" v-else>                    
                    <input type="text" name="enroll_reg" id="enroll_reg" class="form-control"  readonly v-model="dts_penalty.enrollment">
                    <div class="input-group-prepend">
                        <button class="btn btn-outline-danger" type="button" @click="mResetDtsNavy"><font-awesome-icon icon="sync-alt" /></button>
                    </div>
                </div>
                
                
            </div>
        </div>

        <div class="form-row">
            <div class="form-group col-12 col-md-6">
                <label for="trb">Capitan u Armador <span class="required-text">*</span></label>           
                <input type="text" class="form-control" id="captain" placeholder="Capitan u Armador"  autocomplete="off" v-model="dts_penalty.responsability">
            </div>

            <div class="form-group col-12 col-md-3">
                <label for="trb">TRB <span class="required-text">*</span></label>           
                <input type="number" class="form-control" id="trb" placeholder="0"  autocomplete="off" v-model="dts_penalty.trb" @input="mCalculateForm" :readonly="is_disabled">
            </div>

            <div class="form-group col-12 col-md-3">
                <label for="trn">TRN <span class="required-text">*</span></label>           
                <input type="number" class="form-control" id="trn" placeholder="0"  autocomplete="off" v-model="dts_penalty.trn" :readonly="is_disabled">
            </div>
        </div>
        
        <h6>ACTIVIDAD Y PROPULSION DE LA NAVE / EMBARCACION</h6>
        <hr>
        <div class="form-group row">
            <label for="type_boat" class="col-sm-2 col-12 col-form-label">Tipo de Nave</label>
            <div class="col-sm-10 col-12">
                <select name="type_boat" class="form-control" id="type_boat" v-model="dts_penalty.type_boat" @change="mCalculateForm" :disabled="is_disabled">
                    <option v-for="tb in types_boat" :key="tb.id" :value="tb.detail">{{ tb.detail }}</option>
                </select>
                
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-12 col-md-6">
                <label for="nombre_embarcacion">Propulsion <span class="required-text">*</span></label>
                            <!-- listar las capitanias -->
                
                <select name="propulsion" class="form-control" id="propulsion" v-model="propulsion_select" @change="mCalculateForm" v-if="!is_disabled" :disabled="is_disabled">
                    <option v-for="tprop in propulsion_types" :key="tprop.id" :value="tprop">{{ tprop.detail }}</option>
                    <!-- <option v-for="port in ports" :value="port" :key="port.id">{{ port.name_port }}</option> -->
                </select>                         
                <input type="text" class="form-control" id="trb" v-model="propulsion_select.detail" readonly v-else>
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="nombre_embarcacion">Actividad relacionada a: <span class="required-text">*</span></label>
                            <!-- listar las capitanias -->
                <select name="activity" class="form-control" id="activity" v-model="activity_select" @click="mCalculateForm">
                    <option v-for="service in activity_types" :key="service.id" :value="service">{{ service.detail }}</option>
                    <!-- <option v-for="port in ports" :value="port" :key="port.id">{{ port.name_port }}</option> -->
                </select>                         
            </div>
        </div>

        <h6>LUGAR, FECHA y HORA</h6>
        <hr>
        <div class="form-row">
            <div class="form-group col-12 col-md-6">
                <label for="nombre_embarcacion">Puerto <span class="required-text">*</span></label>
                            <!-- listar las capitanias -->
                <select name="port" class="form-control" id="port" v-model="port_select">
                    <option v-for="port in port_lists" :key="port.id" :value="port">{{ port.description }}</option>
                    <!-- <option v-for="port in ports" :value="port" :key="port.id">{{ port.name_port }}</option> -->
                </select>                
            </div>

            <div class="form-group col-12 col-md-6">
                <label for="trb">Localizacion <span class="required-text">*</span></label> 
                <input type="text" class="form-control" id="location" placeholder="Ejm. 1 Km de distancia"  autocomplete="off" v-model="dts_penalty.detail_port_location">
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-12 col-md-3">
                <label for="date_init_ordop">Fecha <span class="required-text">*</span></label>
                <datetime :id="'date_p'" v-model="dts_penalty.date" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
            </div>
            <div class="form-group col-12 col-md-3">
                <label for="time_init_ordop">Hora <span class="required-text">*</span></label>
                <datetime :id="'time_p'" v-model="time_aux" type="time" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" placeholder="Seleccione Hora" title="Hora de Inicio" value-zone="America/La_Paz"></datetime>
            </div>
        </div>
        <h6>INFRACCIONES</h6>
        <hr>
        <div class="form-row">
            <div class="input-group mb-3">
                <!-- <label for="nombre_embarcacion">Infraccion <span class="required-text">*</span></label> -->
                            <!-- listar las capitanias -->
                <select name="port" class="form-control" id="port" v-model="penalty_list_select">
                    <option v-for="pl in penalty_list" :value="pl" :key="pl.id">{{ pl.detail }}</option>
                    <!-- <option v-for="port in ports" :value="port" :key="port.id">{{ port.name_port }}</option> -->
                </select>                
                <div class="input-group-append">
                    <button class="btn btn-outline-success" @click="mAppendInfregment">
                        <font-awesome-icon icon="plus"/>
                    </button>            
                </div>
            </div>            
        </div>
        <div class="col-12 table-responsive" v-if="penalty_lists_approve.length > 0">
        <table class="table table-hover">            
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Descripcion</th>
                        <th scope="col">Opciones</th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for=" (penalty_register, index) in penalty_lists_approve" :key="index">
                    <td scope="row">{{ index+1 }}</td>

                    <td v-if="penalty_register.allow_description === 'S'">                    
                        <div v-if="!penalty_register.is_edit"> {{ penalty_register.detail | upperCase }} </div>                            
                        <textarea type="text" class="form-control" v-else v-model="penalty_select_temp.detail" ></textarea>
                    </td>
                    <td v-else>
                        {{ penalty_register.detail | upperCase}}
                    </td>
                    <td v-if="penalty_register.allow_description === 'S'">
                        <div class="input-group mb-3">
                            <div class="input-group-append" v-if="!penalty_register.is_edit">
                                <button class="btn btn-outline-primary" type="button" @click="mEditPenalty(index)" ><font-awesome-icon icon="edit" /></button>
                                <button class="btn btn-outline-danger" type="button" @click="mDeletePenalty(index)"><font-awesome-icon icon="minus-circle" /></button>
                            </div>
                        
                            <div class="input-group-append" v-else>
                                <button class="btn btn-outline-success" type="button" @click="mSavePenalty(index)"><font-awesome-icon icon="save" /></button>
                                <button class="btn btn-outline-danger" type="button" @click="mCancelEditPenalty(index)"><font-awesome-icon icon="times-circle" /></button>
                            </div>
                        </div>
                    </td>
                    <td v-else>
                        <div class="input-group mb-3">
                            <div class="input-group-append" v-if="!penalty_register.is_edit">
                                <button class="btn btn-outline-danger" type="button" @click="mDeletePenalty(index)"><font-awesome-icon icon="minus-circle" /></button>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
                
            
        </table>
        </div>
        <div class="form-row" v-if="autImport==='S' && total_form > 0 " >
            <button class="btn btn-outline-danger col-md-1 offset-md-5" @click="mEditImport('R')"><font-awesome-icon icon="minus-circle" /></button>           
            <button class="btn btn-outline-danger col-md-1" @click="mEditImport('I')"><font-awesome-icon icon="plus" /></button>
        </div>
        <div class="form-row">
            <div class="col-12 col-md-6">
                <h3><b>Importe: {{ total_form }}</b></h3>
            </div>
            <button class="btn btn-outline-danger col-12 col-md-2 offset-md-2" @click="mRegisterPenalty">
                <font-awesome-icon icon="save" size="3x" />
            </button>
        </div>   
    </div>
    <modal-loading :id-modal="id_modal_penalty" :title="title_modal" :status-send="send_dispatch" ></modal-loading>
    <modal-report :id-modal-report="modal_report" :title="modal_rep_title" :content="modal_rep_content" :url-r="url_report" :id-report="id_reporte" ></modal-report>
</div>  
</template>

<script>

import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';
import modalReport from '../modal/modalReport';

export default {
    name:'penalty',
    mounted(){
        this.callCategoryPenalty();
        this.callPropulsion();
        this.callService();
        this.mCallPortsCaptain()
    },
    data(){
        return {
            is_disabled:false,
            enrollment_temp:'',
            placeholder_enrollment:'Matricula ....',
            enrollments_register:[],
            id_reporte:0,
            url_report:'pdfPenalty',
            modal_rep_content:null,
            modal_rep_title:'Reporte',
            modal_report:'sancion_report',
            send_dispatch:true,
            title_modal:'Registrando',
            id_modal_penalty:'register_penalty',
            category_penalty:[],
            category_penalty_select:{},
            penalty_list:[],
            penalty_list_select:{},
            penalty_lists_approve:[],
            dts_penalty:{
                id_port:0,
                id_master_penalty:0,
                port_dependecy:0,
                detail_port_location:null,
                name_boat:null,
                enrollment:null,
                responsability:null,
                trb:null,
                trn:null,
                type_boat:null,
                propulsion_detail:null,
                propulsion_factor:-1,
                activity_detail:null,
                activity_factor:0,
                danger_activity:0,
                danger_propulsion:0,
                ufv:0,
                number_infregments:0,
                tarifa:0,
                cut:0,
                date:null,
                time:null
            },
            propulsion_types:[],
            propulsion_select:{},
            activity_types:[],
            activity_select:{},
            port_lists:[],
            port_select:{},
            penalty_select_temp:{},
            cut:0,
            total_form:0,
            ufv:0,
            ufv_date:null,
            types_boat:[],
            time_aux:null,
            autImport:'N'
        }
    },
    methods:{
        mEditImport(t='I'){
            let aux_imp=0;
            switch(t){
                case 'I':
                    // incrementamos el importe ya establecido
                    console.log(`decremento el valor ${this.activity_select.factor}`)
                    aux_imp=parseFloat(this.activity_select.factor)+0.1;
                    if(aux_imp>0){
                        this.activity_select.factor=aux_imp;
                        this.mCalculateForm();
                    }
                    break;
                case 'R':
                    // restamos el importe sugerido
                    console.log(`decremento el valor ${this.activity_select.factor}`)
                    aux_imp=parseFloat(this.activity_select.factor)-0.1;
                    if(aux_imp>0){
                        this.activity_select.factor=aux_imp;
                        this.mCalculateForm();
                    }
                    break;
            }
        },
        mResetDtsNavy(){
            this.dts_penalty.type_boat=null;
            this.dts_penalty.name_boat=null;
            this.dts_penalty.enrollment=null;
            this.dts_penalty.trb=0;
            this.dts_penalty.trn=0;
            this.dts_penalty.propulsion_detail=null;
            this.dts_penalty.propulsion_factor=-1;

            this.propulsion_select={};

            this.is_disabled=false;

        },
        mSelectedEnrollment(data){
            console.log(data);
            this.dts_penalty.type_boat=data.detail_boat;
            this.dts_penalty.name_boat=data.name_boat;
            this.dts_penalty.enrollment=data.enrollment;
            this.dts_penalty.trb=data.trb;
            this.dts_penalty.trn=data.trn;
            this.dts_penalty.propulsion_detail=data.detail_propulsion;
            // this.dts_penalty.propulsion_factor=data.factor_propulsion;
            
            this.propulsion_select.id=1;
            this.propulsion_select.detail=data.detail_propulsion;
            this.propulsion_select.factor=data.factor_propulsion;
            this.propulsion_select.factor_penalty=data.factor_penalty;

            this.is_disabled=true;
            this.mCalculateForm();
        },
        mRegisterPenalty(){
            let ef=this.mValidateForm();
            let vi=this.mValidateInfregments();
            if(ef && vi){
                
                this.dts_penalty.id_port=this.cDtsUser.portId;
                this.dts_penalty.id_master_penalty=this.category_penalty_select.id;
                this.dts_penalty.port_dependecy=this.port_select.id;
                this.dts_penalty.propulsion_detail=this.propulsion_select.detail;
                this.dts_penalty.propulsion_factor=this.propulsion_select.factor;
                this.dts_penalty.activity_detail= this.activity_select.detail;
                this.dts_penalty.activity_factor= this.activity_select.factor;
                this.dts_penalty.danger_activity=this.activity_select.factor_penalty;
                this.dts_penalty.danger_propulsion=this.propulsion_select.factor_penalty
                this.dts_penalty.ufv=this.ufv;
                this.dts_penalty.number_infregments=this.penalty_lists_approve.length
                this.dts_penalty.tarifa=this.total_form;
                this.dts_penalty.cut=this.cut;
                
                // console.log(this.dts_penalty);
                // console.log(this.penalty_lists_approve);
                let dts_send={
                    dts_master:JSON.stringify(this.dts_penalty),
                    dts_detail:JSON.stringify(this.penalty_lists_approve)
                }

                let message = {
                    title: 'Sancion',
                    body: `¿Desea Registrar las <b>${this.category_penalty_select.detail}</b> para la Nave / Embarcacion <b>${this.dts_penalty.name_boat.toUpperCase()}</b>?`
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            
                            // this.btn_p_ordop = true;
                            this.activeModal(this.id_modal_penalty);
                            let s_penalty=await axios.post(`registerSancion?api_token=${Vue.auth.getToken()}`, qs.stringify(dts_send))
                            // console.log(s_penalty);
                            setTimeout(()=>{                                
                                // this.btn_p_ordop = false;
                                this.modal_rep_content=s_penalty.data[0].respuesta;
                                    // abrimos el reporte de la sancion
                                this.id_reporte=s_penalty.data[1].id_rep;
                                if(this.id_reporte!==0){
                                    this.clearForm();
                                    this.mResetDtsNavy();
                                }
                                this.activeModal
                                // limpiamos los registros previamente obtenemos el id                                
                                this.inactiveModal(this.id_modal_penalty);
                                this.activeModal(this.modal_report);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error O-01')
                                // this.btn_p_ordop = false;
                                this.inactiveModal(this.id_modal_penalty);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })

            }else{
                console.log('falta completar el formulario');
            }
        },
        clearForm(){
            this.dts_penalty={
                id_port:0,
                id_master_penalty:0,
                port_dependecy:0,
                detail_port_location:null,
                name_boat:null,
                enrollment:null,
                responsability:null,
                trb:null,
                trn:null,
                type_boat:null,
                propulsion_detail:null,
                propulsion_factor:0,
                activity_detail:null,
                activity_factor:0,
                danger_activity:0,
                danger_propulsion:0,
                ufv:0,
                number_infregments:0,
                tarifa:0,
                cut:0,
                date:null,
                time:null
            }
            this.penalty_lists_approve=[];
        },
        mValidateInfregments(){
            let duplicados=[];
            let vp=[];
            let cc=0;
            let cp=0;

            this.penalty_lists_approve.forEach((el, index)=>{
                // console.log(`${el.detail} i=${index}`)
                let text=el.detail;
                let auxText=text.split(" ");

                if(text.length>0){
                    cp=0;
                    auxText.forEach(palabra=>{
                        cp=cp+palabra.length;
                    })
                    if(cp<8){
                        vp.push(index+1);
                    }
                }else{
                    vp.push(index+1);
                }

                for(let i=index+1; i<this.penalty_lists_approve.length; i++){
                    if(this.penalty_lists_approve[i].detail===text){
                    duplicados.push(i);
                    }
                }
            })
            if(duplicados.length > 0){
                toastr.warning('Existen Infracciones iguales', 'Error')
                return false;
                // console.log(indices)
            }else{
                console.log('no existen coincidencias');
            }

            if(vp.length>0){
                let aux_msg="La(s) infraccion(es) numero "
                let ib="";
                vp.forEach(p=>{
                    ib=ib + p + ","
                })
                aux_msg=aux_msg + ib +' '+'deben ser mas especificas';
                toastr.warning(aux_msg, 'Error')
                return false;
            }
            return true;

        },
        mValidateForm(){
            this.dts_penalty.enrollment=this.enrollment_temp;

            if( !(this.category_penalty_select.id > 0) ){
                toastr.warning('Seleccione el tipo de Contravencion', 'Error');
                return false;
            }
            if( !(this.dts_penalty.name_boat!==null) ){
                toastr.warning('Indique el nombre de la Nave / Embarcacion', 'Error');
                return false;
            }
            if( !(this.dts_penalty.enrollment!==null) ){
                toastr.warning('Indique la matricula de la Nave / Embarcacion', 'Error');
                return false;
            }
            if( !(this.dts_penalty.responsability!==null) ){
                toastr.warning('Indique al responsable de la Nave / Embarcacion', 'Error');
                return false;
            }
            if( !(this.dts_penalty.trb!==null && this.dts_penalty.trb!==0) ){
                toastr.warning('Indique el TRB de la Nave / Embarcacion', 'Error');
                return false;
            }

            if( !(this.dts_penalty.trn!==null && this.dts_penalty.trn!==0) ){
                toastr.warning('Indique el TRB de la Nave / Embarcacion', 'Error');
                return false;
            }

            if( !(this.dts_penalty.type_boat!==null) ){
                toastr.warning('Indique el tipo de nave', 'Error');
                return false;
            }

            if( !(this.propulsion_select.id > 0) ){
                toastr.warning('Seleccione el tipo de propulsion de la Nave / Embarcacion', 'Error');
                return false;
            }

            if( !(this.activity_select.id > 0) ){
                toastr.warning('Seleccione el tipo de actividad de la Nave / Embarcacion', 'Error');
                return false;
            }

            if( !(this.port_select.id > 0) ){
                toastr.warning('Seleccione el Puerto de referencia', 'Error');
                return false;
            }

            if( !(this.dts_penalty.detail_port_location !== null) ){
                toastr.warning('Indique la locacion con relacion al puerto', 'Error');
                return false;
            }

            if(this.dts_penalty.date!==null){
                let adi=this.dts_penalty.date.split('T');
                this.dts_penalty.date=adi[0];

                if( this.dts_penalty.date === null || !(this.dts_penalty.date.length === 10) ){
                    toastr.error('La Fecha es incorrecta', 'Error');
                    return false;
                }
            }else{
                toastr.error('Seleccione la Fecha Correcta', 'Error');
                return false;
            }
            // console.log(this.dts_penalty.time);
            
            let ah=this.time_aux.split('T');
            let ah2=ah[1].split(':');
            // console.log(ah2);
            this.dts_penalty.time=ah2[0]+ah2[1];
                // console.log(this.dts_penalty.time);
            if( !(this.dts_penalty.time !== null) && !(this.dts_penalty.time.length >= 3 ) && !(this.dts_penalty.time.length <= 4)  && !(this.dts_penalty.time <=2400) ){
                    toastr.error('La Hora seleccionada es incorrecta', 'Error');
                    return false;
            }
            
            

            if( !(this.penalty_lists_approve.length > 0 ) ){
                toastr.warning('Elija al menos una Infraccion', 'Error');
                return false;
            }

            return true;
        },
        mCalculateForm(){
            this.mCalcCUT();
            let c_penalty=this.penalty_lists_approve.length>0 ? this.penalty_lists_approve.length : 0;
            let result=0;
            let number_enter=0;
            let number_decimal=0;
            let aux_result=0;
            switch(this.category_penalty_select.item){
                case 1:
                    // MCSN=2*U*fmsn*(3+P*A*T*C) SEGURIDAD A LA NAVEGACION                  

                    result=2*this.ufv*c_penalty*(3+this.propulsion_select.factor*this.activity_select.factor*this.dts_penalty.trb*this.cut);

                    aux_result=result.toFixed(2);
                    
                    number_enter=Math.trunc(aux_result);
                    number_decimal=Number((aux_result-number_enter).toFixed(2));

                    if(number_decimal===0.50){
                        result=aux_result;
                            
                    }else if(number_decimal>0.50){
                        result=number_enter+1;
                            
                    }else{                
                        result=number_enter;                            
                    }

                    this.total_form=result;

                    break;
                
                case 2:
                    // MCPC=2*U*fmc*(3+P*pcp*A*pca*T*C) PREVENCION DE LA CONTAMINACION                    

                    result=2*this.ufv*c_penalty*(3+this.propulsion_select.factor*this.propulsion_select.factor_penalty*this.activity_select.factor*this.activity_select.factor_penalty*this.dts_penalty.trb*this.cut);

                    aux_result=result.toFixed(2);

                    number_enter=Math.trunc(aux_result);
                    number_decimal=Number((aux_result-number_enter).toFixed(2));

                    if(number_decimal===0.50){
                        result=aux_result;
                            
                    }else if(number_decimal>0.50){
                        result=number_enter+1;
                            
                    }else{                
                        result=number_enter;                            
                    }

                    this.total_form=result;

                    break;
            }

            // console.log(this.cChangeCUT);
        },
        mCalcCUT(){
            let fact_a=0.1;
            let fact_b=2;
            let fact_c=1.8;
            let fact_d=2.3;
            this.cut=fact_c/(fact_d*(1+fact_a*Math.pow(this.dts_penalty.trb, (1/fact_b) )));
        },
        mVerifyCampEdition(){
            for(let key in this.penalty_lists_approve){
                if( this.penalty_lists_approve[key].is_edit ){
                     this.penalty_lists_approve[key].is_edit=false;
                     this.penalty_select_temp={};
                }
            }
        },
        mEditPenalty(index){
            // crear un temporal de edicion al momento de editar el temporal se debe llenar con los datos anteriores si se acepta la edicion se guarda y reemplaza, NO se mantiene el valor y se elimina el temporal, crear un id o key en cada registro dado que el codigo otros reeemplazara donde sea.
            // verificamos que no haya otro campo en edicion
            this.mVerifyCampEdition();            
            this.penalty_select_temp={
                id:this.penalty_lists_approve[index].id,
                detail:this.penalty_lists_approve[index].detail,
                indice:index
            }
            this.penalty_lists_approve[index].is_edit=true;            
            
        },
        mDeletePenalty(index){
            // let tempVariables = this.penalty_lists_approve.splice(index, 1);
            this.penalty_lists_approve.splice(index, 1);
            this.mCalculateForm();
            // console.log(tempVariables);
            // console.log(this.penalty_lists_approve);
        },
        mSavePenalty(index){            
            // console.log(`terminando de editar el item ${index}`);
            if(this.penalty_select_temp.indice===index){
                this.penalty_lists_approve[index].detail=this.penalty_select_temp.detail.toUpperCase();
                this.penalty_lists_approve[index].is_edit=false;
                this.penalty_select_temp={};
            }else{
                toastr.warning(`Verifique la sancion editada en la fila ${index+1}`);
            }
        },
        mCancelEditPenalty(index){
            this.penalty_lists_approve[index].is_edit=false;
        },
        mAppendInfregment(){
            // console.log(this.penalty_list_select);

            let aux_penalty={
                id:this.penalty_list_select.id,
                detail:this.penalty_list_select.detail,
                allow_description:this.penalty_list_select.allow_description,
                is_edit:false,
                code: (this.penalty_lists_approve.length + 1)
            }
            let verify_dt=this.mVerifyPenaltyList(aux_penalty.id);
            if(verify_dt){
                this.penalty_lists_approve.push(aux_penalty);
                this.mCalculateForm();
            }else{
                toastr.warning('La sancion ya se encuentra registrada','Advertencia');
            }
            // console.log(this.penalty_lists_approve);
        },
        mVerifyPenaltyList(id){
            for(let key in this.penalty_lists_approve){
                if( this.penalty_lists_approve[key].id === id && this.penalty_lists_approve[key].allow_description === 'N' ){
                     return false;                   
                }
            }
            return true;
        },
        async callCategoryPenalty(){
            this.autImport=Vue.auth.getAutImp();
            let od=await axios.get(`ships/contravencion?api_token=${Vue.auth.getToken()}`);
            let u=await axios.get(`ufv?api_token=${Vue.auth.getToken()}`);
            let t_boats=await axios.get(`boats?api_token=${Vue.auth.getToken()}`);
            
            this.types_boat=t_boats.data
            
            // console.log(od);
            this.category_penalty=od.data;
            
            this.ufv=u.data[0].value;
            this.ufv_date=u.data[0].date;
        },
        callUfv(){
            axios.get(`ufv?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                this.ufv=res.data[0].value;
                this.ufv_date=res.data[0].date;
                this.$store.dispatch('addUFV', res.data[0].value);
                this.mCalculateForm();
            })
        },
        callInfregments(){
            this.penalty_list=[];
            this.penalty_lists_approve=[];
            // this.findValue(this.category_penalty_select.id);
                // axios.post('submenu',qs.stringify({parent:this.navegacion.id}))
                let sendNavigate={
                    parent:this.category_penalty_select.id
                }
                axios.post(`submenu?api_token=${Vue.auth.getToken()}`,qs.stringify(sendNavigate))
                .then(res => {                
                    this.penalty_list=res.data
                    // console.log(this.penalty_list)
                    // this.state_navigation_sub=true
                })
        },
        async callPropulsion(){
            let propulsion={
                parent:4
            }
            // axios.post('submenu', qs.stringify(propulsion))
            let tp=await axios.post(`submenu?api_token=${Vue.auth.getToken()}`, qs.stringify(propulsion));
            // console.log(tp.data);
            this.propulsion_types=tp.data
            // .then(res => {                
            //     this.propulsion_types=res.data
            // })
        },
        async callService(){
            // serviceLoad
            let service=await axios.get(`serviceLoad?api_token=${Vue.auth.getToken()}`, qs.stringify(propulsion));
            this.activity_types=service.data
            // .then(res => {                
            //     this.propulsion_types=res.data
            // })
        },
        async mCallPortsCaptain(){
            // let cr=await axios.get(`portsCaptain/${this.cDtsUser.portId}`);
            let cr=await axios.get(`portsCaptain/${this.cDtsUser.portId}?api_token=${Vue.auth.getToken()}`);
            console.log(cr);
            this.port_lists=cr.data;
            // console.log(cr);
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        },
        cChangeCUT(){
            return this.cut;
        },
        cChangeTRB(){
            return this.dts_penalty.trb;
        }
    },
    filters:{
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            value=value.toLowerCase();
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        upperCase: function (value) {
            if (!value) return ''
            value = value.toString()
            value=value.toLowerCase();
            return value.toUpperCase();
        }
    },
    watch:{
        enrollment_temp(newQuery){
            this.enrollments_register=[];
            axios.get(`searchNameBoat/enrollment/${newQuery}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    let temp_enrolls=res.data;
                    
                    temp_enrolls.forEach(dts => {
                        // console.log(dts.enrollment.length);
                        let aux_enroll={
                            detail_boat : dts.detail_boat,
                            detail_propulsion: dts.detail_propulsion,
                            enrollment: (dts.enrollment !== null && dts.enrollment !== '') ? dts.enrollment : dts.enrollment_old,
                            factor_propulsion: dts.factor_propulsion,
                            factor_penalty: dts.factor_penalty,
                            flag:dts.flag,
                            flag_boat:dts.flag_boat,
                            id_boat:dts.id_boat,
                            name_boat:dts.name_boat,
                            trb:dts.trb,
                            trn:dts.trn
                        }
                        this.enrollments_register.push(aux_enroll);
                    })
                    

                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
            })
        }
    },
    components:{
        'modal-loading':modalLoading,
        'modal-report':modalReport
    }
}
</script>

<style>
.required-text{
    color:red; 
    font-weight:bold;
}
</style>


// WEBPACK FOOTER //
// src/components/penalty/Penalty.vue